import {
  ADD_ITEM_GROUP_ID,
  DELETE_ITEM_GROUP_ID,
  GET_ITEM_GROUP_ID,
  UPDATE_ITEM_GROUP_ID,
  GET_ONE_ITEM_GROUP_ID
} from '../types';

// const initialState = { list: [], single: null };
const initialState = {
  list: [],
  pagination: {
    limit: 10,
    nextPage: null,
    totalPages: 1,
    currentPage: 1,
    hasNextPage: false,
    previousPage: null,
    totalProducts: 0,
    hasPreviousPage: false,
  },
  single: null
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ITEM_GROUP_ID:
      return { ...state, list: payload.data , pagination: payload.pagination };

    case UPDATE_ITEM_GROUP_ID:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };

    case ADD_ITEM_GROUP_ID:
      return {
        ...state,
        list: [payload, ...state.list],
      };

    case DELETE_ITEM_GROUP_ID:
      return {
        ...state,
        list: state.list.filter((item) => item.id !== payload.id),
      };
    case GET_ONE_ITEM_GROUP_ID:
      return { ...state, single: payload };

    default:
      return state;
  }
};

export default reducer;
